import _ from 'lodash';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromAuctions from './auction.reducer';

export const selectAuctionsState = createFeatureSelector<fromAuctions.State>(
    fromAuctions.auctionFeatureKey
);

export const selectCurrentAuction = createSelector(
    selectAuctionsState,
    (state: fromAuctions.State) => {
        return state.currentAuctionCampaign
    }
);

export const currentAuctionItemCategoty = createSelector(
    selectAuctionsState,
    (state: fromAuctions.State) => {
        return state.currentAuctionItemCategoty
    }
);

export const selectCurrentAuctionItem = createSelector(
    selectAuctionsState,
    (state: fromAuctions.State) => {
        return state.currentAuctionItem;
    }
);

export const selectBidActivity = createSelector(
    selectAuctionsState,
    (state: fromAuctions.State) => state.currentBiActivity
)

export const selectPendingDonations = createSelector(
    selectAuctionsState,
    (state:fromAuctions.State) => state.currentPendingDonations
)

export const selectPaidDonations = createSelector(
    selectAuctionsState,
    (state: fromAuctions.State) => state.currentPaidDonations
)

export const selectUsersWithFundingSource = createSelector(
    selectAuctionsState,
    (state: fromAuctions.State) => {
        const presetOptions = state.currentAuctionCampaign.campaignTypeData.presetOptions;
        const allBidsWithFundingSource = presetOptions
            .flatMap(option => option.currentBids || [])
            .filter(bid => bid.fundingSource);

        const userMap = new Map<string, { userInfo: any; fundingSource: any }>();

        for (const bid of allBidsWithFundingSource) {
            const userId = bid.userInfo?.id;
            if (userId && bid.fundingSource && !userMap.has(userId)) {
            userMap.set(userId, {
                userInfo: bid.userInfo,
                fundingSource: bid.fundingSource
            });
            }
        }

        return userMap;
    }
)

export const selectAllBidders = createSelector(
    selectAuctionsState,
    (state: fromAuctions.State) => {
        const presetOptions = state.currentAuctionCampaign?.campaignTypeData.presetOptions || [];
        const allBidders = presetOptions.flatMap(item => [
            ...(item.soldItems?.map(s => s.userInfo) || []),
            ...(item.currentBids?.map(b => b.userInfo) || []),
          ]);
        
        const userMap = new Map<string, any>();
        allBidders.forEach(user => {
        if (user?.id && !userMap.has(user.id)) {
            userMap.set(user.id, user);
        }
        });
        
        return Array.from(userMap.values());
    }
)